/* eslint-disable */
import { Spin } from 'antd'
import Header from 'modules/Page/Components/Partials/Header'
import TopNavigation from 'modules/Page/Components/Partials/TopNavigation'
import {
  ContentWrapper,
  PageWrapper,
} from 'modules/Page/Components/Partials/style'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ConfirmationModal from '../../../components/ConfirmationModal'
import { getAppliedRoleMetrics,getNewRoleMetrics } from '../../Applied_Roles/actions'
const { AUTH_URL } = process.env

const Page = ({
  children,
  isOnboarding,
  collegeData,
  signOut,
  getNotificationsList,
  studentData,
  notificationData,
  markNotificationReadApi,
  studentDetails,
  getUserPermissions,
  questionnaire,
  updateStudent,
  registerEvent,
  ApplyRole
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const [isIdle, setIsIdle] = useState(false)
  const dispatch = new useDispatch()
  const { extEventData } = useSelector(state => state?.studentData)
  const [eventApplyModal, setEventApplyModal] = useState(false)
  const [eventApplyTitle, setEventApplyTitle] = useState('')
  const [externalLinkApply, setExternalLinkApply] = useState(false)
  
  useEffect(() => {
    if (extEventData !== null && extEventData?.title) {
      setEventApplyTitle(extEventData?.title)
      setEventApplyModal(true)
    }
  }, [extEventData])

  useEffect(() => {
    if (extEventData !== null && extEventData?.role?.tittle) {
 
      setExternalLinkApply(true)
    }
  }, [extEventData])

  const onEventModalClose = async () => {
    setEventApplyModal(false)
    setEventApplyTitle('')
    await updateStudent({ lastAppliedEventIds: [] })
  }

  const onExternalApplyClose = async () => {
    
    setExternalLinkApply(false)
    await updateStudent({ lastAppliedJobIds: [] })
  }

  const onEventAccept = async () => {
    setEventApplyModal(false)
    setEventApplyTitle('')
    await toRegisterEvent(studentDetails?.lastAppliedEventIds[0])
    await updateStudent({ lastAppliedEventIds: [] })
  }

  const onExternalApply = async () => {
    let payload = {
      id: extEventData?.roleId,
      corporateId: extEventData?.role?.corporate?.id ?? extEventData?.role?.company?.id,
    }
    setExternalLinkApply(false)
    await ApplyRole(payload, false, false)
    await updateStudent({ lastAppliedJobIds: [] })
    navigate('/roles')
   
  }

  const toRegisterEvent = async id => {
    try {
      let payLoad = {
        eventId: id,
        isApplied: 1,
      }
      let requestPayload = {
        studentId: studentDetails?.id,
        instituteCampusId: studentDetails?.instituteCampusId,
        payLoad: payLoad,
      }

      await registerEvent(requestPayload)
    } catch {
      //
    }
  }

  useEffect(() => {
    dispatch(getAppliedRoleMetrics())
    dispatch(getNewRoleMetrics())
  }, [])

  useEffect(() => {
    let idleTimer

    const resetTimer = () => {
      clearTimeout(idleTimer)
      idleTimer = setTimeout(() => setIsIdle(true), 900000)
    }

    const onActivity = () => {
      setIsIdle(false)
      resetTimer()
    }

    resetTimer()

    const eventTypes = [
      'mousemove',
      'keydown',
      'scroll',
      'touchstart',
      'touchmove',
      'touchend',
      'click',
      'mousedown',
      'mouseover',
      'mouseout',
      'mousewheel'
    ]

    eventTypes.forEach(eventType => {
      document.addEventListener(eventType, onActivity, { passive: true })
    })

    return () => {
      clearTimeout(idleTimer)
      eventTypes.forEach(eventType => {
        document.removeEventListener(eventType, onActivity)
      })
    }
  }, [])

  useEffect(() => {
    if (studentDetails?.admin?.admin_role_id) {
      getUserPermissions(studentDetails?.admin?.admin_role_id)
    }
  }, [studentDetails])

  useEffect(() => {
    if (isIdle) {
      // Clear browser history before signing out
      // window.history.pushState(null, '', AUTH_URL)
      // window.history.replaceState(null, '', AUTH_URL)
      
      // // Prevent back navigation
      // window.addEventListener('popstate', () => {
      //   window.history.pushState(null, '', AUTH_URL)
      // })

      


      window.location.href = AUTH_URL
      window.location.replace(AUTH_URL)
      signOut()
     
    }
  }, [isIdle])

  useEffect(() => {
    // if (studentDetails?.currentState) {
    //   if (studentDetails?.currentState === 1) {
    //     navigate(`/onboarding/final/${studentDetails?.id}`)
    //   } else if (studentDetails?.currentState === 2) {
    //     navigate(`/onboarding/register/${studentDetails?.id}`)
    //   } else if (studentDetails?.currentState === 3) {
    //     navigate(`/onboarding/notification/${studentDetails?.id}`)
    //   }
    // }
    setIsLoading(false)
  }, [studentDetails])
  return (
    <PageWrapper>
      {!isLoading ? (
        <>
          <Header
            isOnboarding={isOnboarding}
            collegeData={collegeData}
            signOut={signOut}
            studentData={studentData}
            getNotificationsList={getNotificationsList}
            notificationData={notificationData}
            markNotificationReadApi={markNotificationReadApi}
          />
          {!isOnboarding && !questionnaire && <TopNavigation />}
          <ContentWrapper>{children}</ContentWrapper>
          <ConfirmationModal
            onCloseClick={() => onEventModalClose()}
            open={eventApplyModal}
            actionKey={'lastAppliedEventIds'}
            description={`Did you register for`}
            title={eventApplyTitle}
            onApplyClick={onEventAccept}
          />
          <ConfirmationModal
          onCloseClick={() => onExternalApplyClose()}
          open={externalLinkApply}
          description={`Did you apply for the "${extEventData?.role?.tittle}" position on ${extEventData?.role?.company?.companyName || extEventData?.role?.corporate?.name} company site? `}
          title={''}
          onApplyClick={onExternalApply}
          confirm={false}
        />
        </>
      ) : (
        <Spin />
      )}
    </PageWrapper>
  )
}
export default Page
